module.exports = __webpack_public_path__ + "static/media/workPvcCoatings8.50226894.jpg";